export const FIELDS = {
    REQUISICAO: 'requisicao',
    EQUIPAMENTO: 'equipamento',
    OBSERVACAO: 'observacao',
    DATA_TESTE: 'dataTeste'
};